'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var getTypographicStyle = function getTypographicStyle(theme) {
  return function (_ref) {
    var bold = _ref.bold;
    var center = _ref.center;
    var caps = _ref.caps;

    var result = {};

    if (bold) {
      result.fontWeight = theme.bold;
    }

    if (center) {
      result.textAlign = 'center';
    }

    if (caps) {
      return _extends({}, result, theme.caps);
    }

    return result;
  };
};

exports.default = getTypographicStyle;


//////////////////
// WEBPACK FOOTER
// ./~/rebass/dist/util/get-typographic-style.js
// module id = 5dXu
// module chunks = 1